export const ADD_FILE = 'ADD_FILE';
export const ADD_FILES = 'ADD_FILES';
export const REMOVE_FILE = 'REMOVE_FILE';
export const REMOVE_FILES = 'REMOVE_FILES';
export const EDIT_FILE = 'EDIT_FILE';
export const RESET_FILES = 'RESET_FILES';

export function addFile(value) {
  return {
    type: ADD_FILE,
    value,
    // path,
  };
}

export function addFiles(value) {
  return {
    type: ADD_FILES,
    value,
    // path,
  };
}

export function removeFile(fullPath) {
  return {
    type: REMOVE_FILE,
    fullPath,
  };
}

export function removeFiles(listFullPaths, listPaths) {
  return {
    type: REMOVE_FILES,
    listFullPaths,
    listPaths,
  };
}

export function editFile(value) {
  return {
    type: EDIT_FILE,
    value,
  };
}

export function resetFiles() {
  return {
    type: RESET_FILES,
  };
}
